'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

exports.queryFactory = queryFactory;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _sharedTypeUtils = require('./shared/type-utils');

var _utilsClone = require('./utils/clone');

var _utilsClone2 = _interopRequireDefault(_utilsClone);

var _postprocessingRefDeduplicator = require('./postprocessing/ref-deduplicator');

var _errors = require('./errors');

var _utilsBaseValidator = require('./utils/base-validator');

var _filterFilterMixin = require('./filter/filterMixin');

var _filterFilterMixin2 = _interopRequireDefault(_filterFilterMixin);

var _sortSortMixin = require('./sort/sortMixin');

var _sortSortMixin2 = _interopRequireDefault(_sortSortMixin);

var _sharedValidations = require('./shared/validations');

var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * @class wix-data.WixDataQuery
 * @borrows wix-data.WixDataSort#ascending
 * @borrows wix-data.WixDataSort#descending
 * @borrows wix-data.WixDataFilter#between
 * @borrows wix-data.WixDataFilter#contains
 * @borrows wix-data.WixDataFilter#endsWith
 * @borrows wix-data.WixDataFilter#eq
 * @borrows wix-data.WixDataFilter#ge
 * @borrows wix-data.WixDataFilter#gt
 * @borrows wix-data.WixDataFilter#hasAll
 * @borrows wix-data.WixDataFilter#hasSome
 * @borrows wix-data.WixDataFilter#le
 * @borrows wix-data.WixDataFilter#lt
 * @borrows wix-data.WixDataFilter#ne
 * @borrows wix-data.WixDataFilter#not
 * @borrows wix-data.WixDataFilter#or
 * @borrows wix-data.WixDataFilter#startsWith
 * @summary Contains functionality for refining a data query.
 * @classdesc
 *  The `WixDataQuery` functions enable you to run, sort, filter, and controls
 *  which results a query returns.
 *
 *  Typically, you build a query using the [`query()`](#wix-data.html#query) function,
 *  refine the query by chaining `WixDataQuery` functions, and then execute the
 *  query by chaining the [`find()`](#find) or [`count()`](#count) functions.
 *
 *  For example, the following code queries a collection for all male customers
 *  over the age of 20 and logs the first 15 results to the console, sorted in
 *  ascending order by name:
 *
 *  ```javascript
 *  import wixData from 'wix-data';
 *
 *  wixData.query("Customer")
 *    .gt("age", 20)
 *    .ascending("name")
 *    .limit(15)
 *    .find()
 *    .then( (results) => {
 *      console.log(results.items);
 *    } );
 *  ```
 */

var WixDataQuery = (function (_filterMixin) {
  _inherits(WixDataQuery, _filterMixin);

  function WixDataQuery(obj) {
    _classCallCheck(this, WixDataQuery);

    _get(Object.getPrototypeOf(WixDataQuery.prototype), 'constructor', this).call(this, obj);
    this.provider = obj.provider;
    this.collectionName = obj.collectionName;
    this.limitNumber = obj.limitNumber;
    this.invalidArguments = obj.invalidArguments;
    this.orderBy = obj.orderBy;
    this.skipNumber = obj.skipNumber;
    this.included = obj.included;
  }

  _createClass(WixDataQuery, [{
    key: 'count',

    /**
     * @function count
     * @summary Returns the number of items that match the query.
     * @syntax
     * function count([options: WixDataOptions]): Promise&lt;Number&gt;
     * @param {wix-data~WixDataOptions} [options] - An object with one or both of the following boolean properties: suppressAuth, suppressHooks.
     * @returns {external:Promise}
     * @fulfill {external:Number} The number of items that match the query.
     * @reject {external:Error} The errors that caused the rejection.
     * @description
     *  The `count()` function returns a Promise that resolves to the number of
     *  items that match the query. The Promise is rejected if `count()` is called
     *  with incorrect permissions or if any of the functions used to refine the
     *  query is invalid.
     *
     *  Calling the `count()` function triggers the [`beforeCount()`](wix-data.Hooks.html#beforeCount)
     *  and [`afterCount()`](wix-data.Hooks.html#afterCount) hooks if they have been defined.
     *
     *  Use the `options` parameter to run `count()` without checking for permissions
     *  or without its registered hooks.
     *
     *  Any function that does not filter query results (e.g., [`ascending()`](#ascending))
     *  does not affect the result of `count()`.
     *
     *  If you build a query and don't refine it with any `WixDataQuery` functions,
     *  `count()` returns the total number of items in the collection.
     *
     *  If you have already run a query with [`find()`](#find), you can retrieve
     *  the number of query results without calling `count()`. The [`find()`](#find)
     *  function returns a Promise that resolves to a {@link wix-data.WixDataQueryResult|WixDataQueryResult}
     *  object, which has a `totalCount` property whose value is the number of results.
     * @snippet [WixDataQuery-count.es6=Perform a count on a query]
     * @snippet [WixDataQuery-count_scenario.es6=Create a query and perfom a count on it]
     * @snippet [WixDataQuery-count_scenario_plus.es6=Create a query and perfom a count on it]
     * @memberof wix-data.WixDataQuery
     * @instance
     */
    value: function count(options) {
      var _this = this;

      return rejectIfInvalid(this.invalidArguments, this.collectionName).then(function () {
        return (0, _sharedValidations.apiValidator)().options(options).validateAndReject();
      }).then(function () {
        return _this.provider.count(_this.collectionName, _this.filterTree, options);
      }).then(function (result) {
        return result.totalCount;
      });
    }

    /**
     * @function find
     * @summary Returns the items that match the query.
     * @syntax
     * function find([options: WixDataOptions]): Promise&lt;WixDataQueryResult&gt;
     * @param {wix-data~WixDataOptions} [options] An object with one or both of the following boolean properties: suppressAuth, suppressHooks.
     * @returns {external:Promise}
     * @fulfill {wix-data.WixDataQueryResult} A Promise that resolves to the results of the query.
     * @reject {external:Error} Any errors that caused the query to fail, returned as an array.
     * @description
     *  The `find()` function returns a Promise that resolves to the results found
     *  by the query and some information about the results. The Promise is
     *  rejected if `find()` is called with incorrect permissions or if any of the
     *  functions used to refine the query is invalid.
     *
     *  Calling the `find()` function triggers the [`beforeQuery()`](wix-data.Hooks.html#beforeQuery)
     *  and [`afterQuery()`](wix-data.Hooks.html#afterQuery) hooks if they have been defined.
     *  If the query being run contains an [`include()`](#include), calling `find()`
     *  triggers [`beforeQuery()`](wix-data.Hooks.html#beforeQuery) and
     *  [`afterQuery()`](wix-data.Hooks.html#afterQuery) hooks for the referenced
     *  collection as well.
     *
     *  Use the `options` parameter to run `find()` without checking for permissions
     *  or without its registered hooks.
     *
     *  If you build a query and don't refine it with any `wixDataQuery` functions,
     *  `find()` returns the entire collection.
     * @snippet [WixDataQuery-find.es6=Perform a find on a query]
     * @snippet [WixDataQuery-find_scenario.es6=Create a query and run it]
     * @snippet [WixDataQuery-find_scenario_plus.es6=Create a query and run it]
     * @memberof wix-data.WixDataQuery
     * @instance
     */
  }, {
    key: 'find',
    value: function find(options) {
      var _this2 = this;

      var self = this;

      return rejectIfInvalid(this.invalidArguments, this.collectionName).then(function () {
        return (0, _sharedValidations.apiValidator)().options(options).validateAndReject();
      }).then(function () {
        return _this2.provider.find(_this2.collectionName, _this2.filterTree, _this2.orderBy, _this2.skipNumber, _this2.limitNumber, options, _this2.included);
      }).then(function (result) {
        if (requiredPropertiesIn(result)) {
          var items = (0, _postprocessingRefDeduplicator.wrapAndDeduplicate)(result.items, result.schema, result.references);
          return new WixDataQueryResult({
            length: items.length,
            totalCount: result.totalCount,
            query: self,
            items: items
          });
        } else {
          return new WixDataQueryResult({
            length: result.items.length,
            totalCount: result.totalCount,
            query: self,
            items: result.items
          });
        }
      });
    }

    /**
     * @function limit
     * @summary Limits the number of items the query returns.
     * @syntax
     * function limit(limit: Number): WixDataQuery
     * @param {external:Number} limit The number of items to return, which is also the [`pageSize`](wix-data.WixDataQueryResult.html#pageSize) of the results object.
     * @returns {wix-data.WixDataQuery} A `WixDataQuery` object representing the refined query.
     * @description
     *  The `limit` function defines the number of results a query returns in each
     *  page. Only one page of results is retreived at a time. The {@link wix-data.WixDataQueryResult#next|next()}
     *  and {@link wix-data.WixDataQueryResult#prev|prev()} functions are used to
     *  navigate the pages of a query result.
     *
     *  By default, `limit` is set to `50`.
     *
     *  The maximum value that `limit()` can accept is `1000`.
     * @snippet [WixDataQuery-limit.es6=Add a limit to a query]
     * @snippet [WixDataQuery-limit_scenario.es6=Create a query, add a limit, and run it]
     * @snippet [WixDataQuery-limit_scenario_plus.es6=Create a query, add a limit, and run it]
     * @memberof wix-data.WixDataQuery
     * @instance
     */
  }, {
    key: 'limit',
    value: function limit(limitNumber) {
      var _queryValidator$arityIsOne$isPositiveNumber$isInteger$validateAndAggregate = this._queryValidator('.limit').arityIsOne(arguments).isPositiveNumber(limitNumber).isInteger(limitNumber).validateAndAggregate();

      var _queryValidator$arityIsOne$isPositiveNumber$isInteger$validateAndAggregate2 = _slicedToArray(_queryValidator$arityIsOne$isPositiveNumber$isInteger$validateAndAggregate, 1);

      var newInvalidArguments = _queryValidator$arityIsOne$isPositiveNumber$isInteger$validateAndAggregate2[0];

      return new WixDataQuery({
        provider: this.provider,
        collectionName: this.collectionName,
        filterTree: this.filterTree,
        orderBy: this.orderBy,
        skipNumber: this.skipNumber,
        limitNumber: limitNumber,
        included: this.included,
        invalidArguments: newInvalidArguments
      });
    }

    /**
     * @function skip
     * @summary Sets the number of items to skip before returning query results.
     * @syntax
     * function skip(skip: Number): WixDataQuery
     * @param {external:Number} skip The number of items to skip in the query results before returning the results.
     * @returns {wix-data.WixDataQuery} A `WixDataQuery` object representing the refined query.
     * @description
     *  The `skip()` function defines the number of results to skip in the query
     *  results before returning new query results.
     *
     *  For example, if you query a collection and 50 items match your query, but
     *  you set `skip` to 10, the results returned will skip the first 10 items
     *  that match and return the 11th through 50th items.
     *
     *  By default, `skip` is set to 0.
     * @snippet [WixDataQuery-skip.es6=Add a skip to a query]
     * @snippet [WixDataQuery-skip_scenario.es6=Create a query, add a skip, and run it]
     * @snippet [WixDataQuery-skip_scenario_plus.es6=Create a query, add a skip, and run it]
     * @memberof wix-data.WixDataQuery
     * @instance
     */
  }, {
    key: 'skip',
    value: function skip(skipNumber) {
      var _queryValidator$arityIsOne$isNonNegativeNumber$isInteger$validateAndAggregate = this._queryValidator('.skip').arityIsOne(arguments).isNonNegativeNumber(skipNumber).isInteger(skipNumber).validateAndAggregate();

      var _queryValidator$arityIsOne$isNonNegativeNumber$isInteger$validateAndAggregate2 = _slicedToArray(_queryValidator$arityIsOne$isNonNegativeNumber$isInteger$validateAndAggregate, 1);

      var newInvalidArguments = _queryValidator$arityIsOne$isNonNegativeNumber$isInteger$validateAndAggregate2[0];

      return new WixDataQuery({
        provider: this.provider,
        collectionName: this.collectionName,
        filterTree: this.filterTree,
        orderBy: this.orderBy,
        skipNumber: skipNumber,
        limitNumber: this.limitNumber,
        included: this.included,
        invalidArguments: newInvalidArguments
      });
    }

    /**
     * @function include
     * @summary Includes referenced items for the specified properties in a query's results.
     * @syntax
     * function include(...propertyName: String): WixDataQuery
     * @param {...external:String} propertyName The properties for which to include referenced items.
     * @returns {wix-data.WixDataQuery} A `WixDataQuery` object representing the query.
     * @description
     *  The `include()` function refines a query so that the items returned in the
     *  query's results include the full referenced items for the specified properties.
     *
     *  For example, suppose you have a **books** collection with an **author**
     *  field that references an **authors** collection. Querying the **books**
     *  collection with an `include("author")` will return the relevant book items
     *  and each item will include the full referenced author item in the book's
     *  `author` property.
     *
     *  Querying a collection that contains reference fields without using the
     *  `include()` function returns items that contain only the ID of the
     *  referenced item, and not the full referenced items.
     * @snippet [WixDataQuery-include.es6=Add an include to a query]
     * @snippet [WixDataQuery-include_scenario.es6=Create a query, include a reference field, and run it]
     * @snippet [WixDataQuery-include_scenario_books.es6=Create a query, include a reference field, and run it]
     *  In this example there is a **books** collection which has two reference fields
     *  that reference an **authors** collection and a **publishers** collection.
     *
     *  The query includes the **author** and **publisher** properties so that each
     *  returned book will also include the full items of its referenced author and
     *  publisher.
     * @snippet [WixDataQuery-include_scenario_books_plus.es6=Create a query, include a reference field, and run it]
     *  In this example there is a **books** collection which as two reference fields
     *  that reference an **authors** collection and a **publishers** collection.
     *
     *  The query is refined to only include books from a specific publisher using
     *  the `eq()` function and the publisher's ID.
     *
     *  The query also includes the **author** property so that each returned
     *  book will include the full item of its referenced author.
     * @memberof wix-data.WixDataQuery
     * @instance
     */
  }, {
    key: 'include',
    value: function include() {
      var newIncludedFields = (0, _utilsClone2['default'])(this.included);

      for (var i = 0; i < arguments.length; i++) {
        newIncludedFields.push(arguments[i]);
      }

      return new WixDataQuery({
        provider: this.provider,
        collectionName: this.collectionName,
        filterTree: this.filterTree,
        orderBy: this.orderBy,
        skipNumber: this.skipNumber,
        limitNumber: this.limitNumber,
        invalidArguments: this.invalidArguments,
        included: newIncludedFields
      });
    }
  }, {
    key: '_queryValidator',
    value: function _queryValidator(operatorName) {
      return new QueryValidator(operatorName, this.invalidArguments);
    }
  }, {
    key: 'constructorName',
    get: function get() {
      return 'WixDataQuery';
    }
  }]);

  return WixDataQuery;
})((0, _filterFilterMixin2['default'])((0, _sortSortMixin2['default'])()));

exports.WixDataQuery = WixDataQuery;

function requiredPropertiesIn(result) {
  return result.hasOwnProperty('schema') && result.hasOwnProperty('items');
}

function rejectIfInvalid(invalidArguments, collectionName) {
  if (invalidArguments.length > 0) {
    return Promise.reject((0, _errors.validationError)(_errors.messages.queryInvalid(collectionName, invalidArguments)));
  } else {
    return Promise.resolve();
  }
}

function queryFactory(provider, collectionName) {
  var invalidArguments = (0, _sharedTypeUtils.isString)(collectionName) ? [] : [_errors.messages.queryValidations.collectionNameIsRequired()];
  return new WixDataQuery({
    provider: provider,
    collectionName: collectionName,
    filterTree: {},
    orderBy: undefined,
    skipNumber: undefined,
    limitNumber: 50,
    invalidArguments: invalidArguments,
    included: []
  });
}

function calcSkipNumber(query, len, next) {
  var a = query.skipNumber || 0;
  var b = query.limitNumber === undefined ? len : query.limitNumber;
  if (next) {
    b = Math.min(b, len); //limit how far we can go
  }
  return next ? a + b : a - b;
}

/**
 * @class wix-data.WixDataQueryResult
 * @summary The results of a data query, containing the retrieved items.
 * @classdesc
 *  When you execute a query with the [`find()`](#wix-data.WixDataQuery.html#find)
 *  function, it returns a Promise that resolves to a `WixDataQueryResult` object.
 *  This object contains the items that match the query, information about the
 *  query itself, and functions for paging through the query results.
 */

var WixDataQueryResult = (function () {
  function WixDataQueryResult(obj) {
    _classCallCheck(this, WixDataQueryResult);

    if (!obj) {
      return;
    }

    this._items = obj.items;
    this._totalCount = obj.totalCount;
    this._query = obj.query;

    //todo: to not forget
    //these properties are used by the client - they shouldn't be defined here....BUT since they are, we'll keep them for now, and move them later on to the client.
    this.nextSkipNumber = calcSkipNumber(this.query, this.length, true);
    this.prevSkipNumber = calcSkipNumber(this.query, this.length, false);
  }

  /**
   * @member items
   * @label property
   * @memberof wix-data.WixDataQueryResult
   * @readonly
   * @type {external:Object[]}
   * @syntax
   * get items(): Object[]
   * @summary Returns the items that match the query.
   * @description
   *  The current page of items retrieved by the query.
   *
   *  The page size is defined by the [`limit()`](wix-data.WixDataQuery.html#limit)
   *  function, can be retrieved using the [`pageSize`](#pageSize) property, and
   *  navigating through pages is done with the [`prev()`](#prev) and
   *  [`next()`](#next) functions.
   * @snippet [WixDataQueryResult-items.es6=Get the items of a query result]
   * @snippet [WixDataQueryResult-items_scenario.es6=Perform a query and get the items of the result]
   */

  _createClass(WixDataQueryResult, [{
    key: 'next',

    /**
     * @function next
     * @summary Retrieves the next page of query results.
     * @syntax
     * function next(): Promise&lt;WixDataQueryResult&gt;
     * @description
     *  The `next()` function retrieves the next page of query results.
     *
     *  The page size is defined by the [`limit()`](wix-data.WixDataQuery.html#limit)
     *  function, can be retrieved using the [`pageSize`](#pageSize) property, and
     *  navigating through pages is done with the [`prev()`](#prev) and
     *  [`next()`](#next) functions.
     *
     *  If items are added or removed between calls to `next()` the values returned
     *  by `WixDataQueryResult` may change.
     * @snippet [WixDataQueryResult-next.es6=Get the next page of a query result]
     * @returns {external:Promise}
     * @fulfill {wix-data.WixDataQueryResult} A query result object with the next page of query results.
     * @reject {external:Error} The errors that caused the rejection.
     * @memberof wix-data.WixDataQueryResult
     * @instance
     */
    value: function next() {
      return new WixDataQuery({
        provider: this.query.provider,
        collectionName: this.query.collectionName,
        filterTree: this.query.filterTree,
        orderBy: this.query.orderBy,
        skipNumber: calcSkipNumber(this.query, this.length, true),
        limitNumber: this.query.limitNumber,
        included: this.query.included,
        invalidArguments: []
      }).find();
    }

    /**
     * @function prev
     * @summary Retrieves the previous page of query results.
     * @syntax
     * function prev(): Promise&lt;WixDataQueryResult&gt;
     * @description
     *  The `prev()` function retrieves the previous page of query results.
     *
     *  The page size is defined by the [`limit()`](wix-data.WixDataQuery.html#limit)
     *  function, can be retrieved using the [`pageSize`](#pageSize) property, and
     *  navigating through pages is done with the [`prev()`](#prev) and
     *  [`next()`](#next) functions.
     *
     *  If items are added or removed between calls to `prev()` the values returned
     *  by `WixDataQueryResult` may change.
     * @snippet [WixDataQueryResult-prev.es6=Get the previous page of a query result]
     * @returns {external:Promise}
     * @fulfill {wix-data.WixDataQueryResult} A query result object with the next page of query results.
     * @reject {external:Error} The errors that caused the rejection.
     * @memberof wix-data.WixDataQueryResult
     * @instance
     */
  }, {
    key: 'prev',
    value: function prev() {
      var skip = calcSkipNumber(this.query, this.length, false);
      if (skip < 0) {
        return Promise.reject((0, _errors.validationError)('Failed to perform query on [' + this.query.collectionName + '].\nInvalid prev positioned query skip on a negative number ' + skip + '.'));
      } else {
        return new WixDataQuery({
          provider: this.query.provider,
          collectionName: this.query.collectionName,
          filterTree: this.query.filterTree,
          orderBy: this.query.orderBy,
          skipNumber: skip,
          limitNumber: this.query.limitNumber,
          included: this.query.included,
          invalidArguments: []
        }).find();
      }
    }

    /**
     * @summary Indicates the query has more results.
     * @syntax
     * function hasNext(): boolean
     * @returns {external:Boolean} `true` if there are more results.
     * @function hasNext
     * @memberof wix-data.WixDataQueryResult
     * @snippet [WixDataQueryResult-hasNext.es6=Get whether the query result object has more results]
     * @instance
     */
  }, {
    key: 'hasNext',
    value: function hasNext() {
      if (this.totalCount <= 0) {
        return false;
      }
      var skip = calcSkipNumber(this.query, this.length, true);
      return skip < this.totalCount;
    }

    /**
     * @summary Indicates the query has previous results.
     * @syntax
     * function hasPrev(): boolean
     * @returns {external:Boolean} `true` if there are previous results.
     * @function hasPrev
     * @memberof wix-data.WixDataQueryResult
     * @snippet [WixDataQueryResult-hasPrev.es6=Get whether the query result object has previous results]
     * @instance
     */
  }, {
    key: 'hasPrev',
    value: function hasPrev() {
      if (this.totalCount <= 0) {
        return false;
      }
      var skip = calcSkipNumber(this.query, this.length, false);
      return skip >= 0;
    }
  }, {
    key: 'toJSON',
    value: function toJSON() {
      return {
        items: this._items,
        length: this._items ? this._items.length : 0,
        totalCount: this._totalCount,
        query: this._query
      };
    }
  }, {
    key: 'items',
    get: function get() {
      return this._items;
    }

    /**
     * @member length
     * @label property
     * @memberof wix-data.WixDataQueryResult
     * @readonly
     * @type {external:Number}
     * @syntax
     * get length(): Number
     * @summary Returns the number of items in the current results page.
     * @description
     *  The page size is defined by the [`limit()`](wix-data.WixDataQuery.html#limit)
     *  function, can be retrieved using the [`pageSize`](#pageSize) property, and
     *  navigating through pages is done with the [`prev()`](#prev) and
     *  [`next()`](#next) functions.
     * @snippet [WixDataQueryResult-length.es6=Get the length of a query result]
     * @snippet [WixDataQueryResult-length_scenario.es6=Perform a query and get the length of the result]
     */
  }, {
    key: 'length',
    get: function get() {
      return this.items.length;
    }

    /**
     * @member totalCount
     * @label property
     * @memberof wix-data.WixDataQueryResult
     * @readonly
     * @type {external:Number}
     * @syntax
     * get totalCount(): Number
     * @summary Returns the total number of items that match the query.
     * @description
     *  The `totalCount` returns the total number of items that match the query,
     *  not just the number of items in the current page.
     * @snippet [WixDataQueryResult-totalCount.es6=Get the length of a query result]
     * @snippet [WixDataQueryResult-totalCount_scenario.es6=Perform a query and get the length of the result]
     */
  }, {
    key: 'totalCount',
    get: function get() {
      return this._totalCount;
    }

    /**
     * @member query
     * @label property
     * @memberof wix-data.WixDataQueryResult
     * @readonly
     * @type {wix-data.WixDataQuery}
     * @syntax
     * get query(): WixDataQuery
     * @summary Returns the query used to get the current results.
     * @snippet [WixDataQueryResult-query.es6=Get the query that produced a query result]
     * @snippet [WixDataQueryResult-query_scenario.es6=Perform a query and get the query that produced the result]
     */
  }, {
    key: 'query',
    get: function get() {
      return this._query;
    }

    /**
     * @member pageSize
     * @label property
     * @memberof wix-data.WixDataQueryResult
     * @readonly
     * @type {external:Number}
     * @syntax
     * get pageSize(): Number
     * @summary Returns the query page size.
     * @description
     *  The page size is defined by the [`limit()`](wix-data.WixDataQuery.html#limit)
     *  function, can be retrieved using the [`pageSize`](#pageSize) property, and
     *  navigating through pages is done with the [`prev()`](#prev) and
     *  [`next()`](#next) functions.
     * @snippet [WixDataQueryResult-pageSize.es6=Get the page size of a query result]
     * @snippet [WixDataQueryResult-pageSize_scenario.es6=Perform a query and get the page size of the query result]
     */
  }, {
    key: 'pageSize',
    get: function get() {
      return this._query.limitNumber || 50; //force default
    }

    /**
     * @member totalPages
     * @label property
     * @memberof wix-data.WixDataQueryResult
     * @readonly
     * @type {external:Number}
     * @syntax
     * get totalPages(): Number
     * @summary Returns the total number of pages the query produced.
     * @description
     *  The page size is defined by the [`limit()`](wix-data.WixDataQuery.html#limit)
     *  function, can be retrieved using the [`pageSize`](#pageSize) property, and
     *  navigating through pages is done with the [`prev()`](#prev) and
     *  [`next()`](#next) functions.
     * @snippet [WixDataQueryResult-totalPages.es6=Get the total number of pages in a query result]
     * @snippet [WixDataQueryResult-totalPages_scenario.es6=Perform a query and get the total number of pages in the query result]
     */
  }, {
    key: 'totalPages',
    get: function get() {
      return Math.ceil(this.totalCount / this.pageSize);
    }

    /**
     * @member currentPage
     * @label property
     * @memberof wix-data.WixDataQueryResult
     * @readonly
     * @type {external:Number}
     * @syntax
     * get currentPage(): Number
     * @summary Returns the index of the current results page number.
     * @description
     *  The `currentPage` is a zero-based index of the current page of results.
     *
     *  The page size is defined by the [`limit()`](wix-data.WixDataQuery.html#limit)
     *  function, can be retrieved using the [`pageSize`](#pageSize) property, and
     *  navigating through pages is done with the [`prev()`](#prev) and
     *  [`next()`](#next) functions.
     *
     *  The `currentPage` property returns `undefined` if the query returned no results.
     * @snippet [WixDataQueryResult-currentPage.es6=Get the current page index of a query result]
     * @snippet [WixDataQueryResult-currentPage_scenario.es6=Perform a query and get the current page index of the query result]
     */
  }, {
    key: 'currentPage',
    get: function get() {
      return this.totalCount > 0 && (this.query.skipNumber || 0) < this.totalCount ? Math.floor(this.totalPages * (this.query.skipNumber || 0) / this.totalCount) : undefined;
    }
  }]);

  return WixDataQueryResult;
})();

var QueryValidator = (function (_AggregatingValidator) {
  _inherits(QueryValidator, _AggregatingValidator);

  function QueryValidator(operatorName, previousInvalidArguments) {
    _classCallCheck(this, QueryValidator);

    _get(Object.getPrototypeOf(QueryValidator.prototype), 'constructor', this).call(this, previousInvalidArguments);
    this.operatorName = operatorName;
  }

  _createClass(QueryValidator, [{
    key: '_isNumber',
    value: function _isNumber(specifier, operand) {
      var _this3 = this;

      return this.addValidation(function () {
        return (0, _sharedTypeUtils.isNumber)(operand);
      }, function () {
        return _errors.messages.queryValidations.isNumber(_this3.operatorName, specifier, operand);
      });
    }
  }, {
    key: 'isPositiveNumber',
    value: function isPositiveNumber(operand) {
      var _this4 = this;

      return this._isNumber('positive', operand).addValidation(function () {
        return !Number.isNaN(operand) && operand > 0;
      }, function () {
        return _errors.messages.queryValidations.isPositiveNumber(_this4.operatorName, operand);
      });
    }
  }, {
    key: 'isNonNegativeNumber',
    value: function isNonNegativeNumber(operand) {
      var _this5 = this;

      return this._isNumber('non-negative', operand).addValidation(function () {
        return !Number.isNaN(operand) && operand >= 0;
      }, function () {
        return _errors.messages.queryValidations.isNonNegativeNumber(_this5.operatorName, operand);
      });
    }
  }, {
    key: 'isInteger',
    value: function isInteger(operand) {
      var _this6 = this;

      return this.addValidation(function () {
        return !Number.isNaN(operand) && Number.isFinite(operand) && Number.isInteger(operand) && operand < MAX_SAFE_INTEGER && operand > -MAX_SAFE_INTEGER;
      }, function () {
        return _errors.messages.queryValidations.isInteger(_this6.operatorName, operand);
      });
    }
  }, {
    key: 'notGreaterThan',
    value: function notGreaterThan(operand, value) {
      var _this7 = this;

      return this.addValidation(function () {
        return operand <= value;
      }, function () {
        return _errors.messages.queryValidations.notGreaterThan(_this7.operatorName, operand, value);
      });
    }
  }]);

  return QueryValidator;
})(_utilsBaseValidator.AggregatingValidator);


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-data-core/lib/query.js
// module id = 336
// module chunks = 0